<template>
  <v-dialog
    v-model="parentPortalPresentationOtherDialog"
    persistent
    max-width="300"
  >
    <v-card>
      <v-form ref="portalConfigurationFormRef">
        <v-card-title class="primary-background">
          <span>Modèle du portail</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="parentPortalPresentationOtherDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row v-if="portalConfigurationModel != null">
              <v-col cols="12">
                <v-switch
                  v-model="enableWeatherCity"
                  dense
                  label="Activer la météo"
                  inset
                ></v-switch>
                <v-text-field
                  label="Ville de la météo"
                  v-if="portalConfigurationModel.has_weather != null"
                  v-model="formData.weather_city"
                  :disabled="!enableWeatherCity"
                ></v-text-field>
              </v-col>
              <v-divider></v-divider>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="parentPortalPresentationOtherDialog = false"
          >
            Fermer
          </v-btn>
          <v-btn
            color="primary"
            :disabled="enableWeatherCity && formData.weather_city == ''"
            @click="updatePortal"
            :loading="loadingSave"
          >
            Enregistrer
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { computed, ref, watch, onBeforeMount } from "@vue/composition-api";

export default {
  props: {
    isInherit: Boolean,
    isBuiltIn: Boolean,
    portalOptionsId: Number,
    isGroup: Boolean,
    updatePortalConfiguration: Function,
    id: String,
    portalConfigurationModel: Object,
    group: Object,
    partner: Object,
    portalConfiguration: {
      type: Object,
      required: true,
    },
    portalPresentationOtherDialog: Boolean,
    rules: Object,
    isPortalProfile: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    /* Variables */
    const enableWeatherCity = ref(false);
    const loadingSave = ref(false);
    const formData = ref({
      weather_city: props.portalConfiguration.weather_city,
    });

    /* Computed */
    const parentPortalPresentationOtherDialog = computed({
      get: () => props.portalPresentationOtherDialog,
      set: (value) => {
        emit("update:portalPresentationOtherDialog", value);
      },
    });

    /* Méthodes */
    const updatePortal = async function () {
      loadingSave.value = true;
      await props.updatePortalConfiguration(props.id, formData.value);
      loadingSave.value = false;
      parentPortalPresentationOtherDialog.value = false;
    };

    /* Cycle de vie */
    onBeforeMount(() => {
      if (formData.value.weather_city != "") {
        enableWeatherCity.value = true;
      }
    });

    /* Watchers */
    watch(
      () => enableWeatherCity.value,
      (newValue) => {
        if (!newValue) {
          formData.value.weather_city = "";
        }
      },
      { deep: true }
    );

    return {
      parentPortalPresentationOtherDialog,
      enableWeatherCity,
      formData,
      updatePortal,
      loadingSave,
    };
  },
  methods: {},
};
</script>
